<template>
    <v-form id="form" ref="form" v-model="valid" lazy-validation>
        <v-card id="form_card">
            <v-img
            :src="(item.img_url) ? item.img_url : 'https://elements.lbl.gov/wp-content/uploads/2024/10/Parking-Icon-1025x685-1.png'"
            width="100%"
            :style="{ height: $vuetify.breakpoint.smAndDown ? 'auto' : '400px' }"
            class="white--text align-end"
            >
            <v-card-title
                class="bg-overlay"
                style="font-size: 18px;"
            >
                {{ "(" + item.label + ") " + item.name }}
            </v-card-title>
            </v-img>
            <v-card-text>
                <!-- backend validation messages -->
                <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>

                <v-row style="margin-bottom:-25px;margin-top:0px;">
                    <v-col cols="12" md="6" style="margin-bottom:-20px;">
                        <v-card :class="(selectedOccupancy == 'Zasedeno') ? 'error' : 'success'">
                            <div style="min-height:50px; margin-bottom:0px;text-align:center;">
                                <v-icon dark class="pt-3" v-if="selectedOccupancy == 'Zasedeno'">mdi-close</v-icon>
                                <v-icon dark class="pt-3" v-else-if="selectedOccupancy == 'Samodejni način (štetje vozil)'">mdi-car-3-plus</v-icon>
                                <v-icon dark class="pt-3" v-else>mdi-check</v-icon>
                            </div>
                        </v-card>
                        <v-divider></v-divider>
                        <v-select
                        v-model="selectedOccupancy"
                        :items="occupancyItems"
                        label="Status zasedenosti"
                        solo
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card :class="(selectedIsOpen == 'Ne obratuje') ? 'error' : 'success'">
                            <div style="min-height:50px; margin-bottom:0px;text-align:center;">
                                <v-icon dark class="pt-3" v-if="selectedIsOpen == 'Ne obratuje'">mdi-close</v-icon>
                                <v-icon dark class="pt-3" v-else>mdi-check</v-icon>
                            </div>
                        </v-card>
                        <v-divider></v-divider>
                        <v-select
                        v-model="selectedIsOpen"
                        :items="isOpenItems"
                        label="Status obratovanja"
                        solo
                        />
                    </v-col>
                </v-row>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-text v-if="$vuetify.breakpoint.xsOnly">
                <v-btn block outlined style="margin-bottom:15px;" @click="submitForm()" color="success" :disabled="loading"><v-icon left>mdi-arrow-right</v-icon>Shrani</v-btn>
                <v-btn block outlined style="margin-bottom:15px;" @click="clearForm()" color="error"  :disabled="loading"><v-icon left>mdi-refresh</v-icon>Prekliči</v-btn>
            </v-card-text>
            <v-card-text v-else>
                <v-btn @click="submitForm()" color="success" text :disabled="loading"><v-icon left>mdi-arrow-right</v-icon>Shrani</v-btn>
                <v-btn @click="clearForm()" color="error" text  :disabled="loading"><v-icon left>mdi-refresh</v-icon>Prekliči</v-btn>
            </v-card-text>
        </v-card>
    </v-form>
</template>

<script>

const FormValidationMessages = () => import('@/components/FormValidationMessages.vue')
const FormSubmitMessages = () => import('@/components/FormSubmitMessages.vue')

export default {
    props: ['item'],

    components: {
        FormValidationMessages,
        FormSubmitMessages
    },

    data: () => ({

        valid: true,
        loading: false,

        selectedOccupancy: null,
        selectedIsOpen: null,
        occupancyItems: ['Prosto', 'Zasedeno', 'Samodejni način (štetje vozil)'],
        isOpenItems: ['Obratuje', 'Ne obratuje'],

        backendMessages: [],
        backendErrorMessages: [],
        backendValidationMessages:[],

        name_rules: [v => !!v || 'Polje ime in priimek je obvezno'],
        timeout1: null

    }),

    watch: {
        selectedOccupancy(value) {
            //window.console.log("selectedOccupancy: ", value)
        },

        selectedIsOpen(value) {
            //window.console.log("selectedIsOpen: ", value)
        }
    },

    computed: {
        apiMessages() {
            return this.backendMessages;
        },

        apiErrorMessages() {
            return this.backendErrorMessages 
        },

        apiValidationMessages() {
            return this.backendValidationMessages
        },

        isFullyOccupied() {
            if (this.selectedOccupancy === 'Zasedeno') return 1;
            else if (this.selectedOccupancy === 'Prosto') return 0;
            else return 3;
        }
    },

    methods: {
        submitForm() {
            var vm = this
            if(this.$refs.form.validate()) {
                this.backendValidationMessages = []
                this.backendMessages = []
                this.backendErrorMessages = []
                vm.$store.commit('SET_PROGRESS', true)
                vm.loading = true

                vm.$store.commit('SET_LOADER_TEXT', "Posodobitev stanja je v teku...")
                vm.$store.commit('SET_LOADER', true)

                let payload = {
                    item_type: 'parking',
                    id: vm.item.id,
                    is_open: (vm.selectedIsOpen == 'Obratuje') ? 1 : 0,
                    //is_fully_occupied: (vm.selectedOccupancy == 'Zasedeno') ? 1 : 0,
                    is_fully_occupied: this.isFullyOccupied,
                    uuid: vm.item.uuid
                }

                window.console.log("PAYLOAD")
                window.console.table(payload)
                

                vm.$store.dispatch('UPDATE_MAP_ITEM_PARKING', payload)
                .then(response => {
                    vm.$store.commit('SET_PROGRESS', false)
                    vm.$store.commit('SET_LOADER', false)
                    vm.$store.commit('SET_LOADER_TEXT', 'Stanje je bilo uspešno posodobljeno!')

                    vm.$store.commit('snackbarDisplay', false)
                    vm.$store.commit('snackbarText', "Stanje je bilo uspešno posodobljeno!")
                    vm.$store.commit('snackbarMode', '')
                    vm.$store.commit('snackbarTimeout', 9000)
                    vm.$store.commit('snackbarDisplay', true)

                    vm.backendMessages.push('Stanje je bilo uspešno posodobljeno!');

                    vm.$store.dispatch('MAP_ITEMS')

                    vm.timeout1 = setTimeout(() => {
                        vm.clearBackendMessages()
                    }, 9000)
                })
                .catch(error => {

                    vm.$store.commit('snackbarDisplay', false)
                    vm.$store.commit('snackbarMode', 'multi-line')
                    vm.$store.commit('snackbarText', 'Ups... pri zapisovanju stanja. Poskusite ponovno.')
                    vm.$store.commit('snackbarDisplay', true)

                    console.error(error)
                    if(error.response.status === 422) {
                        window.console.log(error.response.data.errors)
                        for (const property in error.response.data.errors) {
                            //window.console.log(`${property}: ${error.response.data.errors[property]}`);
                            var propertyData = error.response.data.errors[property];
                            //window.console.log(propertyData);
                            propertyData.forEach(message => {
                                vm.backendValidationMessages.push(message);
                            })

                            setTimeout(() => {
                                vm.$vuetify.goTo('#form_card', {
                                    duration: 1000,
                                    offset: 0,
                                    easing: 'easeInOutCubic'
                                })
                            }, 200)
                        }
                    } else {
                        vm.backendErrorMessages.push('Ups... pri zapisovanju stanja. Poskusite ponovno.')
                        setTimeout(() => {
                            vm.$vuetify.goTo('#form_card', {
                                duration: 1000,
                                offset: 0,
                                easing: 'easeInOutCubic'
                            })
                        }, 200)
                    }
                })
                .finally(() =>{
                    vm.loading = false
                    vm.$store.commit('SET_PROGRESS', false)
                    vm.$store.commit('SET_LOADER', false)
                    vm.$store.commit('SET_LOADER_TEXT', '')
                })

                /*
                setTimeout(() =>{
                    vm.loading = false
                    vm.$store.commit('SET_PROGRESS', false)
                    vm.$store.commit('SET_LOADER', false)
                    vm.$store.commit('SET_LOADER_TEXT', 'Stanje je bilo uspešno posodobljeno!')
                },2600)
                */
            }
            else
            {
                setTimeout(() => {
                    vm.$vuetify.goTo('#form_card', {
                        duration: 1000,
                        offset: 0,
                        easing: 'easeInOutCubic'
                    })
                }, 200)
            } 
        },

        clearForm() {
            this.clearBackendMessages()
            if(this.item) {
                if(this.item.is_fully_occupied == 1 || this.item.is_fully_occupied == true) {
                    this.selectedOccupancy = 'Zasedeno'
                } else if (this.item.is_fully_occupied == 3) {
                    this.selectedOccupancy = 'Samodejni način (štetje vozil)'
                } else {
                    this.selectedOccupancy = 'Prosto'
                }

                if(this.item.is_open == 1 ||this.item.is_open == true) {
                    this.selectedIsOpen = 'Obratuje'
                } else {
                    this.selectedIsOpen = 'Ne obratuje'
                }
            }
        },

        clearBackendMessages() {
            this.backendValidationMessages = []
            this.backendMessages = []
            this.backendErrorMessages = []
        }
    },

    created() {

    },

    mounted() {
        if(this.item) {
            if(this.item.is_fully_occupied == 1 || this.item.is_fully_occupied == true) {
                this.selectedOccupancy = 'Zasedeno'
            } else if (this.item.is_fully_occupied == 3) {
                this.selectedOccupancy = 'Samodejni način (štetje vozil)';
            } else {
                this.selectedOccupancy = 'Prosto'
            }

            if(this.item.is_open == 1 ||this.item.is_open == true) {
                this.selectedIsOpen = 'Obratuje'
            } else {
                this.selectedIsOpen = 'Ne obratuje'
            }
        }
    },

    beforeDestroy() {
        clearTimeout(this.timeout1)
    },
}

</script>

<style scoped>
.bg-overlay {
  background: rgba(0, 0, 0, 0.6); /* polprosojno črno ozadje */
  width: 100%;
}
</style>